import React, { useState, useCallback } from "react";
import { Navigation, type TabId } from "./components/Navigation";
import { Calendar } from "./components/Calendar";
import { EntryEditor } from "./components/EntryEditor";
import { Statistics } from "./components/Statistics";
import { Settings } from "./components/Settings";
import "./index.css";

export function App() {
  const [activeTab, setActiveTab] = useState<TabId>("calendar");
  const [editingDate, setEditingDate] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  const handleDaySelect = useCallback((dateStr: string) => {
    setEditingDate(dateStr);
  }, []);

  const handleCloseEditor = useCallback(() => {
    setEditingDate(null);
  }, []);

  return (
    <div
      className="relative min-h-[100dvh]"
      style={{ background: "var(--background)" }}
    >
      {/* Subtle decorative gradient at top */}
      <div
        className="absolute top-0 left-0 right-0 h-64 pointer-events-none"
        style={{
          background: "linear-gradient(180deg, oklch(0.93 0.03 45 / 0.3) 0%, transparent 100%)",
        }}
      />

      {/* Main content */}
      <div className="relative z-10" key={refreshKey}>
        {activeTab === "calendar" && (
          <Calendar onDaySelect={handleDaySelect} />
        )}
        {activeTab === "stats" && <Statistics />}
        {activeTab === "settings" && <Settings onDataChange={handleRefresh} />}
      </div>

      {/* Entry editor modal */}
      {editingDate && (
        <EntryEditor
          dateStr={editingDate}
          onClose={handleCloseEditor}
          onSave={handleRefresh}
        />
      )}

      {/* Bottom navigation */}
      <Navigation activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
}

export default App;
